export const WYSIWYG_TOOLBAR_BUTTONS = [
  { key: "bold",      icon: "fa-bold",                action: "toggleBold",        active: { name: "bold" } },
  { key: "italic",    icon: "fa-italic",              action: "toggleItalic",      active: { name: "italic" } },
  { key: "strike",    icon: "fa-strikethrough",       action: "toggleStrike",      active: { name: "strike" } },
  { key: "underline", icon: "fa-underline",           action: "toggleUnderline",   active: { name: "underline" } },
  { key: "paragraph", icon: "fa-paragraph",           action: "setParagraph",      active: { name: "paragraph" } },
  ...[1, 2, 3].map(level => ({
    key: `h${level}`,
    icon: `mdi-format-header-${level}`,
    action: "toggleHeading",
    options: { level },
    active: { name: "heading", options: { level } },
  })),
  { key: "bullets",   icon: "mdi-format-list-bulleted", action: "toggleBulletList",  active: { name: "bulletList" } },
  { key: "ordered",   icon: "fa-list-ol",               action: "toggleOrderedList", active: { name: "orderedList" } },
  { key: "undo",      icon: "fa-undo",                  action: "undo",              requiresCanRun: true },
  { key: "redo",      icon: "fa-redo",                  action: "redo",              requiresCanRun: true },
];

function applyAction(chain, button) {
  return button.options ? chain[button.action](button.options) : chain[button.action]();
}

export function runToolbarButtonAction(editor, button) {
  if (!editor) return;
  applyAction(editor.chain().focus(), button).run();
}

export function canRunToolbarButton(editor, button) {
  if (!editor) return false;
  return applyAction(editor.can().chain().focus(), button).run();
}

export function isToolbarButtonActive(editor, button) {
  if (!editor || !button.active) return false;
  // editor.isActive() handles undefined attributes gracefully
  return editor.isActive(button.active.name, button.active.options);
}
